import { AxiosRequestConfig } from "axios";
import ApiClient from "@common/web/api/ApiClient";
import AxiosClient from "@common/web/api/vendors/AxiosClient";
import { IRequestOptions } from "@data/model/IRequestOptions";
import { IModelBase } from "@common/data/IModelBase";
import { FormRequestType } from "@/LDE_Modules/ContactForms/FormRequestType";

export default class ApiContactForms extends ApiClient<AxiosClient> {
	constructor(options?: IRequestOptions, settings?: AxiosRequestConfig) {
		options = options || {};
		settings = settings || {};

		const headers = settings.headers || {};
		if (options.token) headers.authorization = `Basic ${options.token}`;

		if (options.portalId || options.userId) {
			const params = settings.params || {};
			if (options.portalId) params.portalId = options.portalId;
			if (options.userId) params.userId = options.userId;
			settings.params = params;
		}

		super(new AxiosClient(settings));
	}

	userData(): Promise<IModelBase> {
		return this.get(`/LDE_Modules/ContactForms/Default.ashx?type=${FormRequestType.UserData}`);
	}

	contactFormRequest(target:FormRequestType, data: IModelBase): Promise<void> {
		return this.post(`/LDE_Modules/ContactForms/Default.ashx?type=${target}`, data);
	}
}
